<template>
    <div class="mb-4 w-full flex flex-col items-start">
        <label
        v-if="label"
        :for="name"
        class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        >
        {{ label }} <span v-if="required" class="text-red-500">*</span>
        </label>

        <select
        :id="name"
        :name="name"
        v-model="selectedValue"
        class="block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
        :class="{ 'border-red-500': error }"
        >
            <!-- Valor por defecto -->
            <option disabled value="">{{ placeholder }}</option>

            <!-- Opciones dinámicas -->
            <option
                v-for="option in options"
                :key="option[optionValue]"
                :value="option[optionValue]"
            >
                {{ option[optionLabel] }}
            </option>
        </select>

        <p v-if="error" class="text-red-500 text-xs italic">{{ errorMessage }}</p>
    </div>
</template>

<script>
export default {
  name: "BaseSelect",
  props: {
    label: String,
    name: { type: String, required: true },

    // ---- NUEVO: valor por defecto ----
    defaultValue: {
      type: [String, Number, Object],
      default: "",
    },

    // Texto mostrado
    optionLabel: {
      type: String,
      default: "label",
    },

    // Value del option
    optionValue: {
      type: String,
      default: "value",
    },

    // Valor actual (Vue 2 compatible)
    value: {
      type: [String, Number, Object],
      default: "",
    },

    options: { type: Array, required: true },

    placeholder: {
      type: String,
      default: "Selecciona una opción",
    },

    required: Boolean,
    error: Boolean,
    errorMessage: String,
  },

  computed: {
    selectedValue: {
      get() {
        // Si no hay valor, devolver el defaultValue
        return this.value !== "" ? this.value : this.defaultValue;
      },
      set(val) {
        this.$emit("input", val); // v-model en Vue 2
      },
    },
  },
};
</script>
